<div class="flex items-center my-2 mx-4 justify-between gap-2">
    <div class="flex items-center gap-2 min-w-0">
        <button class="flex items-center gap-2 border border-[#D7D8DC] rounded-full px-3 py-1.5 text-sm text-grey-700 cursor-pointer shrink-0 bg-transparent"
            (click)="onNewConversationClick()">
            <vw-square-pen-icon class="w-4 h-4 shrink-0 flex"></vw-square-pen-icon>
            <span>{{ 'willy.new-conversation' | translate }}</span>
        </button>
        @if (isReported) {
          <p class="text-sm truncate">{{
            'common.modals.ai-actions.content.message.reported' |
            translate
            }}</p>
        }
    </div>
    <div class="flex items-center">
        <vw-icon-button [look]="'clear'" [iconTemplate]="infoIconTemplate" (onClick)="onInfoClick()">
            <ng-template #infoIconTemplate>
                <vw-info-icon class="w-5 h-5"></vw-info-icon>
            </ng-template>
        </vw-icon-button>
        <vw-icon-button [look]="'clear'" [iconTemplate]="flagIconTemplate" (onClick)="onFlagClick()">
            <ng-template #flagIconTemplate>
                <vw-flag-icon class="w-5 h-5"></vw-flag-icon>
            </ng-template>
        </vw-icon-button>
    </div>

</div>
<vw-report-modal [isOpen]="showReportPopup" (onReport)="onReport()"
    (onModalClosed)="showReportPopup = false"></vw-report-modal>
<vw-ai-chatbot-info-modal [isOpen]="showInfoPopup" (onModalClosed)="onInfoModalClose()"></vw-ai-chatbot-info-modal>